<ng-container *ngIf="searchInput != null; else loading">
  <div class="search-input-container">
    <div class="search-input-fields-container">
      <div class="input-field">
        <div class="input-field-label more-margin">Jobnummer</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field appearance="outline">
            <input
              matInput
              type="number"
              [(ngModel)]="searchInput.projectId"
              (ngModelChange)="storeInputSubject.next()"
            />
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset jobnummer',
                resetFunction: resetProjectId.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="upper-space input-field">
        <div class="input-field-label more-margin no-form-field-padding">
          Klantnaam
        </div>
        <div class="input-field-value no-form-field-padding d-flex">
          <div class="value-input">
            <company-picker
              [company]="searchInput.company"
              [canEdit]="true"
              [fullWidth]="true"
              (companyIsSelected)="companySelected($event)"
            ></company-picker>
          </div>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset klant',
                resetFunction: resetCompany.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div *ngIf="contactChoices?.length > 0" class="input-field">
        <div class="input-field-label more-margin">Contactpersoon</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Contactpersoon"
              [(ngModel)]="searchInput.contact"
              [compareWith]="compareEntities"
              (ngModelChange)="storeInputSubject.next()"
            >
              <mat-option
                *ngFor="let contact of contactChoices"
                [value]="contact"
                >{{
                  contact.firstName | personName: contact.lastName
                }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset contactpersoon',
                resetFunction: resetContact.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="more-upper-space input-field">
        <div class="input-field-label more-margin">Straat</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <input
              matInput
              [(ngModel)]="searchInput.street"
              (ngModelChange)="storeInputSubject.next()"
            />
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset straat',
                resetFunction: resetStreet.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="input-field">
        <div class="input-field-label more-margin">Huisnummer</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <input
              matInput
              [(ngModel)]="searchInput.number"
              (ngModelChange)="storeInputSubject.next()"
            />
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset huisnummer',
                resetFunction: resetNumber.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="input-field">
        <div class="input-field-label more-margin">Gemeente</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <input
              matInput
              [(ngModel)]="searchInput.city"
              (ngModelChange)="storeInputSubject.next()"
            />
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset gemeente',
                resetFunction: resetCity.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="input-field">
        <div class="input-field-label more-margin">Postcode</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <input
              matInput
              [(ngModel)]="searchInput.postalCode"
              (ngModelChange)="storeInputSubject.next()"
            />
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset klant',
                resetFunction: resetPostalCode.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="more-upper-space input-field">
        <div class="input-field-label more-margin">Type opdracht</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Alle"
              [multiple]="true"
              [(ngModel)]="searchInput.subProjectTypes"
              (ngModelChange)="subProjectTypeChanged()"
            >
              <mat-option
                *ngFor="let type of subProjectTypeChoices"
                [value]="type.key"
                >{{ type.display }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset type opdracht',
                resetFunction: resetSubProjectTypes.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="input-field">
        <div class="input-field-label more-margin">Type bord</div>
        <div class="input-field-value no-form-field-padding d-flex">
          <mat-form-field class="value-input all-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Alle"
              [multiple]="true"
              [(ngModel)]="searchInput.boardTypeSearchParameters"
              (ngModelChange)="storeInputSubject.next()"
            >
              <mat-option
                *ngFor="let type of boardTypeSearchChoices"
                [value]="type.key"
                >{{ type.display }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <ng-container
            *ngTemplateOutlet="
              resetButton;
              context: {
                tooltipText: 'Reset type bord',
                resetFunction: resetBoardTypes.bind(this)
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="more-upper-space">
        <mat-checkbox
          [(ngModel)]="searchInput.noCompletedRepo"
          (ngModelChange)="storeInputSubject.next()"
          ><b>Toon alleen jobs die nog niet zijn weggehaald</b></mat-checkbox
        >
      </div>
      <div>
        <mat-checkbox
          [(ngModel)]="searchInput.pending"
          (ngModelChange)="storeInputSubject.next()"
          ><b>Toon alleen de opdrachten die nog uitgevoerd moeten worden</b>
        </mat-checkbox>
      </div>
      <div class="more-upper-space d-flex justify-content-between">
        <button mat-button class="button" (click)="resetInput()">
          Wis
        </button>
        <button mat-button class="button" (click)="submitInput()">
          Zoek
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <mat-spinner color="primary" diameter="75"></mat-spinner>
</ng-template>
<ng-template
  #resetButton
  let-tooltipText="tooltipText"
  let-resetFunction="resetFunction"
>
  <button
    class="reset-button"
    (click)="resetFunction()"
    [matTooltip]="tooltipText"
    [disableRipple]="true"
    mat-icon-button
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</ng-template>
